import React from 'react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offerta" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-176" data-mp="17xuswfmwwmsb">
      <div className="mx-auto max-w-md" data-id="element-177" data-mp="1mo254dmbt9kk">
        <div className="text-center" data-id="element-178" data-mp="1mmqy84xl3lp8">
          <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-teal" data-id="element-179" data-mp="1hophhqnmrygx">
            Pagamento unico
          </span>
          <h2 className="mt-4 font-display text-[1.75rem] font-black leading-tight tracking-tight text-navy sm:text-[2.4rem]" data-id="element-180" data-mp="tzwfpdkbuwee">
            Offerta di Lancio{' '}
            <span className="italic text-grape" data-id="element-181" data-mp="13wrelxkiiyt7">Imbattibile</span>
          </h2>
        </div>

        <div className="relative mt-12 rounded-3xl border-2 border-tangerine bg-white px-7 pb-8 pt-11 shadow-soft" data-id="element-182" data-mp="yxxzy1thp1rg">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-tangerine px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-183" data-mp="2fbofq5tz1egx">
            Pack Musica Pronta
          </span>

          <dl data-id="element-184" data-mp="pj5v4pirqkej">
            {offerRows.map(row => <div key={row.label} className="flex items-center justify-between gap-4 border-b border-navy/10 py-4 text-sm" data-id="element-185" data-mp="ujbn66sya8x5">
                <dt className="text-navy/75" data-id="element-186" data-mp="zgagin4sibua">{row.label}</dt>
                <dd className="font-bold text-navy" data-id="element-187" data-mp="13iyq4x1bvmsb">{row.value}</dd>
              </div>)}
            <div className="flex items-center justify-between gap-4 border-b border-navy/10 py-4 text-sm" data-id="element-188" data-mp="6use3p22ts40">
              <dt className="font-bold uppercase tracking-wide text-navy" data-id="element-189" data-mp="btlubp8qzx7v">
                Valore totale:
              </dt>
              <dd className="font-bold text-navy/40 line-through" data-id="element-190" data-mp="ft4bqb1d1q5y">€97</dd>
            </div>
          </dl>

          <p className="mt-6 text-center text-[11px] font-extrabold uppercase tracking-[0.18em] text-teal" data-id="element-191" data-mp="kn8o59teaqef">
            Oggi a soli
          </p>
          <div className="border-b border-navy/10 pb-7 pt-2 text-center" data-id="element-192" data-mp="3o9fq1qy05nx1">
            <p className="text-base font-medium leading-none text-navy/30 line-through sm:text-lg" data-id="element-193" data-mp="vfqtjs3t4ung">
              €97
            </p>
            <p className="mt-2 font-display text-6xl font-black leading-none text-tangerine" data-id="element-194" data-mp="qfmg6ay74g1g">
              €19
            </p>
          </div>

          <CtaButton label="Scarica tutto il pack" className="mt-7 w-full" data-id="element-195" data-mp="157mynn4b9l16" />

          <p className="mt-4 text-center text-[11px] font-medium text-navy/50" data-id="element-196" data-mp="106z3qqcyok1o">
            Pagamento unico · Accesso illimitato · Download istantaneo
          </p>
        </div>
      </div>
    </section>;
}